import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { pagedList, sortDirection } from "@/models/pagedList";
import { CustomerInfoModel } from "@/models/customerModels";
import { Message, SisasImportItem } from "@/models/importModels";
@Component({})
export default class importMessaggiList extends Vue {
  @Prop({ default: [] })
  messaggi: Array<Message>;

  get items(): Array<Message> {
    return this.messaggi == null ? [] : this.messaggi;
  }
  getVariant(item: Message): string {
    if (item == null)
      return '';
    if (item.tipo == "INFO")
      return "info";
    if (item.tipo == "WARNING")
      return "warning";
    if (item.tipo == "ERROR")
      return "danger";
    return '';
  }
}
